import { HackneyGraphId, PlayerProfile } from "../../../types/alice-bob";
import { createEffect, createStore } from "effector";
import { $playerProfile, fetchMe } from "./playerProfile";
import { claimFriendApi } from "../api/api";

export type ReferralStatus = { data: HackneyGraphId, claimed: boolean }

export const $playerReferrals = createStore<Array<ReferralStatus>>(new Array());
$playerReferrals.on(fetchMe.doneData, (_, response) => {
    if (!response.refs || response.refs.length == 0) return new Array();
    else return recalculateReferrals(response.player, response.refs);
})

export const recalculateReferrals = (player: PlayerProfile, refs: HackneyGraphId[]): Array<ReferralStatus> => {
    const newArray = new Array<ReferralStatus>();
    for (const ref of refs) {
        newArray.push({
            data: ref,
            claimed: (player.friends_claimed || []).some(claimed => claimed.hackneyId == ref.id)
        })
    }
    return newArray
}

export const claimFriend = createEffect(async (friendHackneyId: string) => {
    return await claimFriendApi(friendHackneyId);
});

$playerReferrals.on(claimFriend.doneData, (_, response) => {
    if (!response.refs || response.refs.length == 0) return new Array();
    else return recalculateReferrals(response.player, response.refs);
})

$playerProfile.on(claimFriend.doneData, (_, payload) => {
    return payload.player
})